import { useEffect, useState, Fragment } from "react";
import QuestionsLeftPane, { Category, FilterValue } from "./QuestionsLeftPane";
import RawScoreCard from "./RawScoreCard";
import FinalScoreCard from "./FinalScoreCard";
import QuestionContent from "./QuestionContent";
import Explanation from "./Explanation";
import { useGetUserResultsByIdQuery } from "../../redux/API/StartTest/startTestApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { useNavigate, useParams } from "react-router-dom";
import { getItem, setItem } from "../../utils/token";
import {
  setIsTestStarted,
  setResetFilters,
  setQid,
  setIsTestInstructionsOpen,
  setFilters,
  setIsFullTestResultScreen,
} from "../../redux/Slices/startFullTestSlice";
import LinkExpired from "../ReUsableComponents/LinkExpired";
import AuthButton from "../../pages/LogInPage/LoginButton";
import { setCurrentQuestionIndex } from "../../redux/Slices/resultSlice";
import { setCurrentQuestion } from "../../redux/Slices/resultSlice";
import { jwtDecode } from "jwt-decode";
import FiltersPopUp from "./FiltersPopUp";
import DashboardBackground from "../ReUsableComponents/DashboardBackground";
import SideBarV1 from "../../pages/NewDashboard/SideBarV1";
import HeaderV1 from "../../pages/NewDashboard/HeaderV1";
import { Tab } from "@headlessui/react";
import { AssessmentTab } from "../../pages/NewResults/ResultPageTabs";
import ErrorPage from "../../pages/ApiErrorPage";
// Types

export type ScoreModule = {
  name: string;
  score: string;
  total?: string;
  subModules?: {
    name: string;
    score: string;
  }[];
};
export type ScoreSection = {
  title: string;
  totalScore: string;
  modules: ScoreModule[];
};
const TestResults = () => {
  const { id } = useParams();
  const params = new URLSearchParams(window.location.search);
  const tokenParam = params.get("token");
  const istokenParam = tokenParam ? true : false;

  useEffect(() => {
    if (tokenParam) {
      setItem("route", `/practices/results/${id}`);
      setItem("token", atob(tokenParam));
      setItem("isLogin", "true");
      const decoded: any = jwtDecode(atob(tokenParam));
      setItem("userName", decoded?.firstName);
      setItem("userRole", decoded?.role ?? null);
      setItem("userEmail", decoded?.userEmail);
      setItem("userId",decoded?.id);
      const expiryTime = decoded.exp;
      if (expiryTime) {
        setItem("expiryTime", expiryTime.toString());
      }
    }
  }, [id, tokenParam]);

  const isParent = getItem("userRole") === "PARENT";
  const userId = isParent ? getItem("studentId") ?? "" : "";
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsTestStarted(false));
    dispatch(setIsTestInstructionsOpen(false));
  }, [dispatch]);

  const { error,isError } = useGetUserResultsByIdQuery(
    { userId, userTestId: id || "" },
    { refetchOnMountOrArgChange: true, skip: !id }
  );

  const navigate = useNavigate();
  const role = getItem("userRole");

  useEffect(() => {
    if (error && "status" in error) {
      if (error.status === 400) {
        if (role === "STUDENT") {
          navigate("/dashboard");
        } else {
          navigate("/parentdashboard");
        }
      } else if (error.status === 401){
        navigate('/login')
      }
    }
  }, [error, role]);

  return (
    <>
      <DashboardBackground>
        {isError ? (
          <ErrorPage />
        ) : (
          <div className="p-5 flex gap-[1%] w-full">
            {/* Sidebar */}
            <SideBarV1 />

            <section
              className="flex flex-col justify-center items-start gap-[2vh]"
              style={{
                width: "calc(100vw - 240px)",
                height: "calc(100vh - 40px)",
              }}
            >
              <HeaderV1 />

              <div
                className=""
                style={{ height: "calc(100vh - 12vh - 40px)",width: "calc(100vw - 240px)" }}
              >
                <Tab.Group>
                  <Tab.List className="relative flex gap-[5px]">
                    <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`font-gully py-[10px] px-[22px] rounded-t-[10px] text-base  focus:outline-none ${
                            selected
                              ? "text-satPrepAccent border-[0.5px] border-satPrepGrey border-b-0 bg-satPrepTransWhite"
                              : "bg-[#ffffff73] text-satPrepDarkGrey"
                          }`}
                          role="tab"
                        >
                          Test Details
                        </button>
                      )}
                    </Tab>
                    <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`font-gully py-[10px] px-[22px] rounded-t-[10px] text-base  focus:outline-none ${
                            selected
                              ? "text-satPrepAccent border-[0.5px] border-satPrepGrey border-b-0 bg-satPrepTransWhite"
                              : "bg-[#ffffff73] text-satPrepDarkGrey"
                          }`}
                          role="tab"
                        >
                          Performance Metrics
                        </button>
                      )}
                    </Tab>
                  </Tab.List>

                  <Tab.Panels>
                    <Tab.Panel>
                      <div className="pl-3 py-3 pr-1 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] rounded-tl-none border-[0.5px] border-t-0  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive" style={{height: "calc(100vh - 12vh - 85px)"}}>
                        <ResultData/>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel>
                      <div className="py-2 pr-1 w-full flex flex-grow justify-between items-center self-stretch rounded-[28px] rounded-tl-none border-[0.5px] border-t-0  border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive" style={{height: "calc(100vh - 12vh - 85px)"}}>
                        <AssessmentTab testId={id} />
                        {/* Bottom Gradient */}
                        {/* <div 
                          className="absolute bottom-1 rounded-b-lg h-10 pointer-events-none"  
                          style={{
                            background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.56) 49.52%, rgba(255, 255, 255, 0.75) 100%)",
                            width: "calc(100vw - 264px)"
                          }}
                        /> */}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              </div>
            </section>
          </div>
        )}
      </DashboardBackground>
    </>
  );
};

export default TestResults;

const ResultData = () => {
  const dispatch = useDispatch();

  const [openPanels, setOpenPanels] = useState({
    rawScore: true,
    finalScore: true,
  });
  const [showFilters, setShowFilters] = useState(false);

  const { isFullTestResultScreen, filteredData, filters } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const togglePanel = (panel: keyof typeof openPanels) => {
    setOpenPanels({ ...openPanels, [panel]: !openPanels[panel] });
  };

  const toggleFilter = (category: Category, value: FilterValue) => {
    const newValue =
      !filters[category][value as keyof (typeof filters)[Category]];
    const categoryValues = Object.values(filters[category]);
    if (!newValue && categoryValues.filter(Boolean).length === 1) return;
    dispatch(
      setFilters({
        ...filters,
        [category]: {
          ...filters[category],
          [value]:
            !filters[category][value as keyof (typeof filters)[Category]],
        },
      })
    );
  };

  useEffect(() => {
    return () => {
      dispatch(setQid(""));
      dispatch(setCurrentQuestion(""));
      dispatch(setCurrentQuestionIndex(""));
      dispatch(setResetFilters());
      dispatch(setIsFullTestResultScreen(false))
    };
  }, []);

  return(
    <div className="h-full py-2 w-full widgetScroll">
      <div className="grid grid-cols-[auto,1fr] gap-2" style={{ height: "calc(100vh - 12vh - 120px)" }}>
        <div className="relative h-full overflow-y-auto">
          {!isFullTestResultScreen && (
            <QuestionsLeftPane
              setShowFilters={setShowFilters}
              showFilters={showFilters}
            />
          )}
          {/* Filters Dropdown */}
          {showFilters && (
            <FiltersPopUp
              toggleFilter={toggleFilter}
              showFilters={showFilters}
              setShowFilters={setShowFilters}
            />
          )}
        </div>
        <div className={"flex flex-col flex-grow"}>
          {!isFullTestResultScreen && (
            <div className="flex gap-2 mb-2">
              {/* Raw Score Card */}
              <RawScoreCard
                togglePanel={(panel) =>
                  togglePanel(panel as "rawScore" | "finalScore")
                }
                openPanels={openPanels}
              />

              {/* Final Score Card */}
              <FinalScoreCard
                togglePanel={(panel) =>
                  togglePanel(panel as "rawScore" | "finalScore")
                }
                openPanels={openPanels}
              />
            </div>
          )}
          <div
            className="p-6 shadow-widget-card backdrop-blur-sevenFive bg-satPrepTransWhite rounded-[28px] border-[0.5px] border-satPrepGrey mb-[10px] font-gully"
          >
            <QuestionContent />
          </div>
          {!isFullTestResultScreen && filteredData?.length > 0 && (
            <div
              className="p-6 shadow-widget-card backdrop-blur-sevenFive bg-satPrepTransWhite rounded-[28px] border-[0.5px] border-satPrepGrey font-gully"
            >
              <Explanation />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
